<template>
  <div class="smoke-effect" mode="currentLevel" v-if="true">
    <div class="smoke-item" v-for="(item,idx) in items" :key="idx" :style="itemStyle(item)"></div>
  </div>
</template>

<script>
export default {
  name: 'smoke-effect',
  data: function () {
    return {
      items: [],
      createProc: null,
      currentLevel: null
    }
  },
  mounted: function () {
    this.currentLevel = this.level
    this.resetSmoke()
  },
  methods: {
    resetSmoke: function () {
      this.items.splice(0, this.items.length)
      clearTimeout(this.createProc)
      this.createProc = setInterval(this.createSmoke.bind(this), 150)
    },
    createSmoke: function () {
      const py = 45 + Math.round(Math.random() * 10) - 5
      const size = 24 + Math.round(Math.random() * 10)
      const bgtrans = 0.5 + Math.round(Math.random() * 10 / 2) / 10
      this.items.push({
        x: 38 + Math.round(Math.random() * 18),
        y: py,
        size: size,
        bg: 'rgba(0,0,0,' + bgtrans + ')',
        delay: Math.round(Math.random() * 10) / 100
      })
      if (this.items.length === 20) {
        clearTimeout(this.createProc)
      }
    },
    itemStyle: function (item) {
      return {
        left: item.x + '%',
        top: item.y + '%',
        fontSize: item.size + 'px',
        backgroundColor: item.bg,
        animationDelay: item.delay + 's'
      }
    }
  },
  props: {
    level: Number,
    active: Boolean
  },
  watch: {
    level: function (newValue) {
      this.currentLevel = newValue
      this.resetSmoke()
    },
    active: function (newValue) {
      if (newValue) {
        this.resetSmoke()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.smoke-effect{
  opacity: 0;
  position: absolute;
  z-index: 2;
  overflow: hidden;
  top: -100px;
  left: 0;
  width: 100%;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 70%;
  }
  .smoke-item{
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 99% 99%;
    background-color: #000;
    opacity: 0;
    transition: margin-left linear .2s;
    --filter: blur(1.5px);
  }
}
.challenge[stopped='true'] .smoke-effect{
  display: none;
}
@keyframes sizing1{
  0%{
    opacity: 0;
    width: 1em;
    height: 1em;
    top: 85%;
  }
  2%{
    opacity: 0.8;
    width: 0.9em;
    height: 0.9em;
    margin-left: 1%;
  }
  50%{
    opacity: 0.5;
    width: 0.5em;
    height: 0.5em;
    top: 50%;
    margin-left: 10%;
  }
  100%{
    opacity: 0.0;
    width: 0.2em;
    height: 0.2em;
    top: 30%;
    margin-left: 20%;
  }
}
@keyframes sizing2{
  0%{
    opacity: 0;
    width: 1.2em;
    height: 1.2em;
    top: 85%;
  }
  2%{
    opacity: 0.8;
    top: 65%;
    width: 1.2em;
    height: 1.2em;
    margin-left: 5%;
  }
  50%{
    opacity: 0.7;
    width: 0.7em;
    height: 0.7em;
    top: 30%;
    margin-left: 15%;
  }
  100%{
    opacity: 0.0;
    width: 0.25em;
    height: 0.25em;
    top: 0%;
    margin-left: 40%;
  }
}
div {
  &[broken='true']{
    .smoke-effect{
      opacity: 1;
      > .smoke-item {
        animation: sizing2 1s ease-in-out 0s infinite;
      }
    }
  }
  &[broken='true'][repairlevel='1']{
    .smoke-effect{
      opacity: 0.7;
      > .smoke-item {
        animation: sizing1 1s ease-in-out 0s infinite;
      }
    }
  }
}
@media (max-height: 880px){
  .smoke-effect{
    height: 164px;
  }
}
@media (max-height: 700px){
  .smoke-effect{
    height: 160px;
    left: -4px;
  }
}
@media (max-height: 660px){
  .smoke-effect{
    height: 156px;
    left: -8px;
  }
}
</style>
